//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  queryCheckIdentityJumpStatus,
  recognitionIdCard,
  uploadCard1,
  uploadCard2,
  uploadIdentifyPhone,
} from '@/https/user'
import checkFront from '@/assets/img/check_front.png'
import checkBack from '@/assets/img/check_back.png'
import { danger } from '@/utils/notify.js'
import { warning } from '@/utils/notify'
import { checkCard } from '@/utils/validator'

export default {

  data () {
    return {
      checkFront,
      checkBack,
      uploadList: [],
      loading: false,
      uploadBackList: [],
      formData: {
        validDate: '',
        idNum: '',
        name: '',
      },
    }
  },

  methods: {
    uploadIdentifyPhone,

    uploadBackSuccess (val) {
      this.doCheck({
        cardSide: 'back',
        imageUrl: val[0].url,
      })
    },

    async uploadSuccess (val) {
      this.doCheck({
        cardSide: 'front',
        imageUrl: val[0].url,
      })
    },

    async doCheck (params) {
      const backFlag = params.cardSide === 'back'

      const { message, code, data } = await recognitionIdCard(params)

      if (code !== 0) {
        danger(message)
      } else {
        if (backFlag) {
          this.formData.validDate = data.validDate
        } else {
          this.formData.idNum = data.idNum
          this.formData.name = data.name
        }
      }
    },

    async doSubmit () {
      if (!this.uploadList[0]?.url) {
        warning('请先上传身份证件正面照')

        return
      }

      if (!this.uploadBackList[0]?.url) {
        warning('请先上传身份证件反面照')

        return
      }

      if (!this.formData.idNum) {
        warning('尚未识别身份证号码，请上传证件正面照！')

        return
      }

      if (!checkCard(this.formData.idNum)) {
        warning('身份证号码识别有误！')

        return
      }

      if (!this.formData.name) {
        warning('尚未识别姓名，请上传证件正面照！')

        return
      }

      if (this.formData?.name?.length >= 30) {
        warning('姓名不能超过30个字符')

        return
      }

      if (!this.formData.validDate) {
        warning('尚未识别证件有效期，请上传证件反面照！')

        return
      }

      this.submit()
    },

    async submit () {
      this.loading = true
      const result = await queryCheckIdentityJumpStatus()

      if (+result.data === 1) {
        const { code, message, data } = await uploadCard1({
          ...this.formData,
          imageUrlFront: this.uploadList[0]?.url,
          imageUrlBack: this.uploadBackList[0]?.url,
        })

        if (code !== 0) {
          danger(message)
        } else {
          const a = document.createElement('a')

          a.setAttribute('href', data)
          a.click()
        }
      } else {
        const { code, message } = await uploadCard2({
          ...this.formData,
          imageUrlFront: this.uploadList[0]?.url,
          imageUrlBack: this.uploadBackList[0]?.url,
        })

        if (code !== 0) {
          danger(message)
        } else {
          this.$router.replace('/myself')
        }
      }

      this.loading = false
    },

  },
}
